export default __webpack_public_path__ + "static/media/img1.79513df3.jfif";